<div class="col-lg-12 padding-20">
    <div class="row m-0">
        <div class="col-lg-12 header block text-white" [ngClass]="'bg-' + dialogClass">
            <i [ngClass]="dialogIcon"></i>
            <h5 class="card-title text-secondary bold-font padding-top-5 header-title">{{dialogTitle}}</h5>
        </div>
        <div class="col-lg-12 card-body border-right border regular-font" [ngClass]="'border-' + dialogClass">

            <div class="message-box">
                <p class="card-text semi-bold-font padding-top-5 message" [innerHtml]="message"></p>
                <div>
                    <mat-form-field *ngIf="showInputText" class="padding-left-20 width-80" >
                        <mat-label>{{inputLabel}}</mat-label>
                        <input matInput [(ngModel)]="inputText">
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field *ngIf="showTextArea" class="padding-left-20 width-80">
                        <mat-label>{{textAreaLabel}}</mat-label>
                        <textarea matInput [(ngModel)] = "textAreaText"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="text-right padding-10 action-buttons">
                <button type="button" class="btn ok-btn bold-font" [ngClass]="'btn-' + dialogClass"
                        (click)="onConfirm()">{{okBtnText}}
                </button>
                <button type="button" class="btn margin-left-10 cancel-btn bold-font"
                        [ngClass]="'btn-outline-' + dialogClass" *ngIf="showCancelBtn" (click)="onDismiss()">{{cancelBtnText}}
                </button>
            </div>
        </div>

    </div>
</div>
